// HERA-7894: Replace full issue/kudo arrays with integer counts after scoring
// to free memory. Extracted to its own module so unit tests can import it
// without pulling in the full app dependency tree.
export function stripArraysAfterScoring(associates) {
    associates.forEach(da => {
        da.issuesCount = da.issues ? da.issues.length : 0
        da.kudosCount = da.kudos ? da.kudos.length : 0
        delete da.issues
        delete da.kudos
        delete da.issuesPrev
        delete da.kudosPrev
    })
}
